import * as actionTypes from "../../Actions";

const initialState = {
    actionLogs: []
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_ACTION_LOGS:
            return {
                ...state,
                actionLogs: action.payload
            }
        default:
            return state;
    }
}

export default reducer;
